"use client";

import Slider from "react-slick";
import { CAROUSEL_SETTINGS, carouselStyles } from "../../lib/carousel";
const styles = new Proxy({"Carousel":"Carousel-4dd43","Title":"Title-4dd43","SlideOuter":"SlideOuter-4dd43","Card":"Card-4dd43","CardTitle":"CardTitle-4dd43","CardAuthors":"CardAuthors-4dd43","BtnWrap":"BtnWrap-4dd43","Btn":"Btn-4dd43","BtnDownload":"BtnDownload-4dd43"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const DEFAULT_SLIDES: CarouselSlide[] = [
  {
    title:
      "Feature space reduction method for ultrahigh-dimensional, multiclass data: RFMS",
    authors:
      "Gergely Hanczár, Marcell Stippinger, Dávid Hanák, Marcell T. Kurbucz, Olivér Máté Törteli, Ágnes Chripkó and Zoltán Somogyvári",
    ctaLabel: "Read more",
    ctaHref: "#",
  },
  {
    title:
      "Detection of mild cognitive impairment based on mouse movement data of trail making test",
    authors:
      "Dr. Gergely Hanczár, Dr. Erika Griechisch, Nóra Ovád, Olivér Máté Törteli, Gábor Tóth, Dávid Hanák, Balázs Vértes, Dr. András Horváth & Prof. Dr. Anita Kamondi",
    ctaLabel: "Read more",
    ctaHref: "#",
  },
  {
    title:
      "BiometricBlender: Ultra-high dimensional, multi-class synthetic data generator to imitate biometric feature space",
    authors:
      "Dr. Gergely Hanczár, Olivér Máté Törteli, Dávid Hanák, Marcell Stippinger, Marcell T. Kurbucz & Zoltan Somogyvari",
    ctaLabel: "Read more",
    ctaHref: "#",
  },
  {
    title:
      "Real-time continuous authentication using mouse movement biometrics",
    authors: "Dávid Hanák, Gergely Hanczár, Olivér Máté Törteli",
    ctaLabel: "Read more",
    ctaHref: "#",
  },
  {
    title:
      "Signature verification in banking: a large-scale evaluation of deep learning approaches",
    authors:
      "Marcell T. Kurbucz, Gergely Hanczár, Dávid Hanák & Olivér Máté Törteli",
    ctaLabel: "Read more",
    ctaHref: "#",
  },
];

export default function Carousel({ block }: CarouselProps) {
  const { title = "Scientific Papers", slides, anchor = "" } = block;
  const usedSlides = slides?.length ? slides : DEFAULT_SLIDES;

  return (
    <section id={anchor} className={styles.Carousel}>
      <div className="container">
        <h2 className={styles.Title}>{title}</h2>
        <div className={carouselStyles.SliderWrap}>
          <Slider
            {...CAROUSEL_SETTINGS}
            slidesToShow={Math.min(usedSlides.length, 3)}
            className="CarouselSlider"
          >
            {usedSlides.map((slide, i) => (
              <div key={i} className={styles.SlideOuter}>
                <div className={styles.Card}>
                  <p className={styles.CardTitle}>{slide.title}</p>
                  <p className={styles.CardAuthors}>{slide.authors}</p>
                  <div className={styles.BtnWrap}>
                    {slide.ctaLabel && slide.ctaHref && (
                      <a
                        href={slide.ctaHref}
                        className={`${styles.Btn}${slide.ctaDownload ? ` ${styles.BtnDownload}` : ""}`}
                        target="_blank"
                        rel="noreferrer"
                        {...(slide.ctaDownload ? { download: true } : {})}
                      >
                        {slide.ctaLabel}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export type CarouselSlide = {
  title: string;
  authors?: string;
  ctaLabel?: string;
  ctaHref?: string;
  ctaDownload?: boolean;
};

export type CarouselProps = {
  block: {
    title?: string;
    slides?: CarouselSlide[];
    anchor?: string;
  };
};
